import { deviceWidth } from '@/utils/deviceWidth';
import { getYoutubeId } from '@/utils/getYoutubeId';
import { MAX_MOBILE_WIDTH } from '@/utils/constants';
import React, { useEffect, useState } from 'react';

function YouTubeViewer(props) {
  const { linkUrl } = props;
  const isMobile = deviceWidth <= MAX_MOBILE_WIDTH;
  const [youtubeUrl, setYoutubeUrl] = useState();

  useEffect(() => {
    const youtubeVideoId = getYoutubeId(linkUrl);
    const youtubeLink = `https://www.youtube.com/embed/${youtubeVideoId}`;
    setYoutubeUrl(youtubeLink);
  }, [linkUrl]);

  return (
    <iframe
      width={isMobile ? '100%' : '600'}
      height={isMobile ? '100%' : '600'}
      style={{ objectFit: 'cover' }}
      src={youtubeUrl}
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    ></iframe>
  );
}

export default YouTubeViewer;
